import React from 'react';

import CustomerTable from './CustomerTable.js';

function CustomerReport(props) {
    const { customers, onSelectCustomer } = props;

    if (!(customers?.length > 0)) {
        return null;
    }

    return (
        <CustomerTable
            showAll
            showPayments
            customers={customers}
            onSelectCustomer={onSelectCustomer}
            initialState={{
                columns: {
                    columnVisibilityModel: {
                        ownerName: false,
                        updatedAt: false,
                        trial: false,
                    },
                },
            }}
        />
    );
}

export default CustomerReport;
